import { render } from "./DueDate.vue?vue&type=template&id=29cf3b10&scoped=true"
import script from "./DueDate.vue?vue&type=script&lang=js"
export * from "./DueDate.vue?vue&type=script&lang=js"

import "./DueDate.vue?vue&type=style&index=0&id=29cf3b10&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-29cf3b10"

export default script